import React from "react";
export var CampaignPOInput = /*#__PURE__*/ React.forwardRef(function BaseCampaignPOInput(param, ref) {
    var onChange = param.onChange, name = param.name, po = param.po;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h5", null, "Add a PO / invoice ID"), /*#__PURE__*/ React.createElement("input", {
        type: "text",
        placeholder: "PO / invoice ID",
        onChange: onChange,
        defaultValue: po,
        name: name,
        ref: ref,
        "data-testid": "po-input-testid"
    }));
});
